"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var use_strategy_alignment_1 = require("./use-strategy-alignment");
Object.defineProperty(exports, "useStrategyAlignment", { enumerable: true, get: function () { return use_strategy_alignment_1.useStrategyAlignment; } });
